import { Pipe, PipeTransform } from '@angular/core';

import { Antrag } from '../../types';

@Pipe({
  name: 'canSendAntrag',
  standalone: true,
})
export class CanSendAntragPipe implements PipeTransform {
  public async transform(
    antrag: Antrag,
    maximumSize: number, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    justSomethingToTrickChangeDetection: number,
  ): Promise<boolean> {
    if (!antrag.hasSeiten()) {
      return false;
    }

    const currentSize = await antrag.getSizeInBytes();
    const sizeExceeded = maximumSize < currentSize / 1024 / 1024;

    return !sizeExceeded;
  }
}
